import React from 'react';
import './GameGrid.css'; // Reuse the same styles as GameGrid

const AdditionalBuylistGrid = ({ categories, onCategorySelect }) => {
  if (!categories || categories.length === 0) {
    return null; // Don't render anything if there are no categories
  }

  // Function to generate a color based on the button label
  const getButtonColor = (label) => {
    // Simple hash function to generate a color based on the label
    const hash = label.split('').reduce((acc, char) => {
      return char.charCodeAt(0) + ((acc << 5) - acc);
    }, 0);

    // Generate a hue between 0 and 360
    const hue = Math.abs(hash % 360);

    // Return an HSL color with fixed saturation and lightness
    return `hsl(${hue}, 70%, 65%)`;
  };

  return (
    <div className="alt-game-grid" style={{ marginTop: '2rem' }}>
      <h2>Additional Items</h2>
      <div className="alt-grid-container">
        {categories.map((category, index) => {
          const backgroundColor = getButtonColor(category.button_label);

          return (
            <div
              key={index}
              className="alt-game-card"
              onClick={() => onCategorySelect(category)}
            >
              <div className="alt-game-image-container">
                <div className="alt-game-image">
                  <div
                    className="alt-game-image-inner"
                    style={{
                      backgroundColor,
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '8px'
                    }}
                  >
                    <span style={{ color: 'white', fontWeight: 'bold', fontSize: '20px' }}>
                      {category.button_label.charAt(0)}
                    </span>
                  </div>
                </div>
              </div>
              <div className="alt-game-title">
                {category.button_label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AdditionalBuylistGrid;
